<div id="ombudsman" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Ombudsperson</h2>
    <p class="inner-lead mt-3">
      As per University Grants Commission (Redressal of Grievances of Students) Regulations, 2023, Chaudhary Devi Lal
      University (CDLU), Sirsa, has appointed <strong>Sh. S.P. Vats</strong>, Retd. Registrar, Kurukshetra University as
      the University Ombudsperson for redressal of grievances of students.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Official Notification</h4>

    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/grievances/Ombudsperson.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:680px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-3">
      <a href="/assets/pdf/grievances/Ombudsperson.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> View / Download Official Notification
      </a>
    </div>

  </div>
</div>